// package: profile
// file: apigateway/profile/user.proto

import * as apigateway_profile_user_pb from "../../apigateway/profile/user_pb";
export class UserService {
  static serviceName = "profile.UserService";
}
export namespace UserService {
  export class GetUser {
    static readonly methodName = "GetUser";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_pb.GetUserRequest;
    static readonly responseType = apigateway_profile_user_pb.UserReply;
  }
  export class GetMyUser {
    static readonly methodName = "GetMyUser";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_pb.GetMyUserRequest;
    static readonly responseType = apigateway_profile_user_pb.UserReply;
  }
  export class GetUserRelation {
    static readonly methodName = "GetUserRelation";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_pb.GetUserRelationRequest;
    static readonly responseType = apigateway_profile_user_pb.UserRelationReply;
  }
  export class GetMyGlobalPopup {
    static readonly methodName = "GetMyGlobalPopup";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_pb.GetMyGlobalPopupRequest;
    static readonly responseType = apigateway_profile_user_pb.GetMyGlobalPopupReply;
  }
  export class GetMyProviderStatus {
    static readonly methodName = "GetMyProviderStatus";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_profile_user_pb.GetMyProviderStatusRequest;
    static readonly responseType = apigateway_profile_user_pb.GetMyProviderStatusReply;
  }
}
